import {Button, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"
import {useNavigate, useParams} from "react-router-dom"

import {Page} from "@indebted/components/Page"
import {PaymentCompletedImage} from "@indebted/assets"
import {Props, Prop, PropValue, PropLabel} from "@indebted/components/Props"
import {useAnalytics} from "@indebted/analytics"

function PaymentSucceeded({ClientName, Amount, I18n}) {
	const navigate = useNavigate()
	const {secureCode} = useParams()
	const {track} = useAnalytics()

	function makeAnotherPaymentButtonClicked() {
		track("PartialPaymentMakeAnotherPaymentButtonClicked", {
			SecureCode: secureCode,
		})
		navigate(`/${secureCode}`)
	}

	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.PaymentSucceeded.Title}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center">{I18n.PaymentSucceeded.Subtitle}</Typography>
			</Grid>

			<GridImage>
				<PaymentCompletedImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel>{I18n.PaymentSucceeded.PaymentAmountLabel}</PropLabel>
					<PropValue>{Amount}</PropValue>
				</Prop>
				<Prop>
					<PropLabel>{I18n.PaymentSucceeded.PaidToLabel}</PropLabel>
					<PropValue className="amp-mask">{ClientName}</PropValue>
				</Prop>
			</Props>
			<Grid>
				<Button onClick={makeAnotherPaymentButtonClicked} style={{marginTop: "35px"}}>
					{I18n.PaymentSucceeded.MakeAnotherPaymentButtonText}
				</Button>
			</Grid>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {PaymentSucceeded}
